<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="应用名称">
              <a-input v-model="query.appName" placeholder="请输入应用名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="水司名称">
              <a-input v-model="query.tenantName" placeholder="请输入水司名称" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()"  v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()"   v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
    <div slot='nameAction'  slot-scope="text">
      <a-tooltip :title="text">
       <div  :title="text"  :style="{maxWidth:'90px',whiteSpace:'nowrap',textOverflow:'ellipsis',overflow:'hidden',wordWrap:'break-word',wordBreak:'break-all'}">
          {{text}}
       </div>
    </a-tooltip>
    </div>
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record)"   v-action:edit>编辑</a>
      </span>
      <span slot="appAction" slot-scope="text, record">
          {{record.appNames.join(',')}}
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用名称">
          <a-select
          mode="multiple"
            :allowClear='false'
            show-search
            style="width: 100%"
            placeholder="请选择应用"
            v-decorator="['appIds',{rules: [{ required: true, message: '请选择应用'}],initialValue: undefined }]"
            :filterOption="false"
            @search="fetchApp"
          >
            <a-select-option
              v-for="item in appList"
              :key="item.id"
              :value="item.id"
              :label="item.appName"
            >{{ item.appName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水司名称" >
          <a-select
           :disabled="this.isUpdate"
            allowClear
            show-search
            style="width: 100%"
            placeholder="请选择水司"
            v-decorator="['tenantId',{ rules: [{ required: true, message: '请选择水司'}],initialValue: undefined }]"
            :filterOption="false"
            @search="fetchTenant"
          >
            <a-select-option
              v-for="item in tenantList"
              :key="item.tenantId"
              :value="item.tenantId"
              :label="item.tenantName"
            >{{ item.tenantName }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const columns = [
  {
    title: '水司名称',
    dataIndex: 'tenantName'
  },
  {
    title: '应用名称',
    dataIndex: 'appName',
    scopedSlots:{ customRender: 'appAction'}
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data() {
    return {
      appList: [],
      tenantList: [],
      queryAppUrl: '/manager/apps',
      queryTenantUrl: '/manager/tenants',
      queryUrl: '/manager/tenant-apps',
      deleteUrl: '/manager/tenant-apps',
      addOrUpdateUrl: 'manager/tenant-apps',
      query: {
        appName: '',
        tenantName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created() {
    this.init()
  },
  methods: {
     queryList () {
      // console.info(this.dataForm)
      // 评分年份(决策分析应用)
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,

        ...this.query
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          // if (res.code !== 0) {
          //   this.dataList = []
          //   this.total = 0
          //   return this.$message.error(res.msg)
          // }
          // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? (this.mixinViewModuleOptions.getImgIsPage ? res.data.records : res.data.list) : res.data
          // this.total = parseInt(this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0)
          if (this.needPage) {
            this.list = data.list || []
            // this.list.length?this.list.map(item=>{
            //   item.appName=item.appNames.join(' , ')
            // }):''
            this.pagination.total = data.total ? parseInt(data.total) : 0
            console.log(this.list)
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    fetchApp(value) {
      console.log('fetching user', value)
      let params = {
        params: {
          appName: value
        }
      }
      this.$http
        .get(this.queryAppUrl, params)
        .then(({ data }) => {
          this.appList = data
        })
        .catch(({ e }) => {
          console.log(e)
        })
    },
    fetchTenant(value) {
      let params = {
        params: {
          tenantName: value
        }
      }
      console.log(params)
      this.$http
        .get(this.queryTenantUrl, params)
        .then(({ data }) => {
          
          this.tenantList = data
        })
        .catch(({ e }) => {
          console.log(e)
        })
    },
    detailInfo(record) {
      this.detailForm = { ...record }
    },
    edit(record) {
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(record)
      })
    },
    init() {
      this.getTenantList()
      this.getAppList()
    },
    getTenantList() {
      this.$http
        .get(this.queryTenantUrl)
        .then(({ data }) => {
          this.tenantList = data
        })
        .catch(({ e }) => {
          console.log(e)
        })
    },
    getAppList() {
      this.$http
        .get(this.queryAppUrl)
        .then(({ data }) => {
          this.appList = data
        })
        .catch(({ e }) => {
          console.log(e)
        })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
